import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Link } from 'react-scroll';  // 导入react-scroll的Link组件

export const HeroSection = () => {
  const { t, i18n } = useTranslation();

  // 使用状态管理表单字段
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [message, setMessage] = useState<string | null>(null); // 用于显示反馈信息

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault(); // 阻止表单默认提交行为

    try {
      const response = await fetch("./send-email.php", {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setMessage(t("hero.form.successMessage")); // 显示成功信息
        setFormData({ name: "", email: "", phone: "", message: "" }); // 清空表单字段
      } else {
        setMessage(t("hero.form.errorMessage")); // 显示失败信息
      }
    } catch (error) {
      console.error("Error submitting the form:", error);
      setMessage(t("hero.form.errorMessage")); // 显示失败信息
    }
  };

  return (
      <div className="relative bg-gradient-to-r from-[#0A1929] to-[#1A2B3C] text-white">
        <div className="container mx-auto px-4 py-16 grid md:grid-cols-2 gap-12 items-center min-h-[600px]">
          <div className="space-y-6">
            <h1 className="text-5xl font-bold leading-tight text-[#bc943e]">
              {t("hero.title")}
            </h1>
            <p className="text-xl text-gray-300">{t("hero.subtitle")}</p>
            <ul className="space-y-4 list-none text-gray-300 text-lg">
              {[1, 2, 3, 4, 5].map((index) => (
                  <li key={index} className="flex items-center gap-2">
                    <div className="w-2 h-2 bg-[#F0B341] rounded-full"></div>
                    {t(`hero.services.${index}`)}
                  </li>
              ))}
            </ul>
            <Link
                to="contact-section" // 设置目标元素的ID
                smooth={true}
                duration={500}
            >
              <Button
                  variant="outline"
                  className="bg-[#F0B341] text-white hover:bg-[#F0B341]/90 border-none mt-8"
              >
                {t("hero.contact")}
              </Button>
            </Link>
          </div>
          <div className="bg-[#0A1929]/90 p-8 rounded-lg shadow-xl">
            {/* 表单开始 */}
            <form onSubmit={handleSubmit} className="space-y-4">
              <h3 className="text-xl font-semibold text-white mb-6">
                {t("hero.form.title")}
              </h3>
              <Input
                  name="name"
                  placeholder={t("hero.form.name")}
                  className="w-full bg-transparent border-gray-600 text-white placeholder:text-gray-400"
                  value={formData.name}
                  onChange={handleChange}
                  required
              />
              <Input
                  name="email"
                  placeholder={t("hero.form.email")}
                  type="email"
                  className="w-full bg-transparent border-gray-600 text-white placeholder:text-gray-400"
                  value={formData.email}
                  onChange={handleChange}
                  required
              />
              <Input
                  name="phone"
                  placeholder={t("hero.form.phone")}
                  type="tel"
                  className="w-full bg-transparent border-gray-600 text-white placeholder:text-gray-400"
                  value={formData.phone}
                  onChange={handleChange}
                  required
              />
              <Textarea
                  name="message"
                  placeholder={t("hero.form.message")}
                  className="w-full bg-transparent border-gray-600 text-white placeholder:text-gray-400 min-h-[100px]"
                  value={formData.message}
                  onChange={handleChange}
                  required
              />
              <Button
                  type="submit"
                  className="w-full bg-[#F0B341] hover:bg-[#F0B341]/90 text-white"
              >
                {t("hero.form.submit")}
              </Button>
            </form>
            {/* 显示反馈消息 */}
            {message && (
                <div className="mt-4 text-center">
                  <p className="text-white bg-gray-800 p-2 rounded">{message}</p>
                </div>
            )}
          </div>
        </div>
      </div>
  );
};
